var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
var CircularGauge = forwardRef(function (_a, ref) {
    var percentage = _a.percentage, _b = _a.currentValue, currentValue = _b === void 0 ? 0 : _b, _c = _a.maxValue, maxValue = _c === void 0 ? 100 : _c, _d = _a.size, size = _d === void 0 ? "md" : _d, system = _a.system, color = _a.color, legend = _a.legend, horizontal = _a.horizontal, _e = _a.className, className = _e === void 0 ? "" : _e, style = _a.style, otherProps = __rest(_a, ["percentage", "currentValue", "maxValue", "size", "system", "color", "legend", "horizontal", "className", "style"]);
    var radius = 45;
    var circumference = 2 * Math.PI * radius;
    var strokeDashArray = (percentage / 100) * circumference;
    var circularGaugeClass = "ssg-circular-gauge";
    var circularGaugeText = "ssg-circular-gauge__text";
    if (size === "sm") {
        circularGaugeClass += " ssg-circular-gauge--sm";
    }
    if (color) {
        circularGaugeClass += " ssg-circular-gauge--" + color;
    }
    else if (system) {
        circularGaugeClass += " ssg-circular-gauge--" + system;
    }
    else {
        circularGaugeClass += " ssg-circular-gauge--info";
    }
    if (className) {
        circularGaugeClass += " " + className;
    }
    if (horizontal) {
        circularGaugeClass += " ssg-circular-gauge--horizontal";
        circularGaugeText = undefined;
    }
    return (React.createElement("div", __assign({}, otherProps, { className: circularGaugeClass, style: style, ref: ref }),
        React.createElement("svg", { className: "ssg-circular-gauge__svg", viewBox: "0 0 100 100" },
            React.createElement("circle", { className: "ssg-circular-gauge__background", cx: "50", cy: "50", r: radius }),
            React.createElement("circle", { className: "ssg-circular-gauge__fill", cx: "50", cy: "50", r: radius, style: {
                    strokeDasharray: "".concat(strokeDashArray, " ").concat(circumference),
                } }),
            React.createElement("text", { x: "50%", y: "50%", className: "ssg-circular-gauge__pourcentage", dy: "5.6px" },
                percentage,
                "%")),
        React.createElement("div", { className: circularGaugeText },
            currentValue !== undefined && maxValue !== undefined && (React.createElement("p", { className: "ssg-circular-gauge__values" },
                React.createElement("span", { className: "ssg-circular-gauge__current" }, currentValue),
                " /",
                " ",
                React.createElement("span", { className: "ssg-circular-gauge__max" }, maxValue))),
            legend && React.createElement("p", { className: "ssg-circular-gauge__legend" }, legend))));
});
export default CircularGauge;
